import { funcType } from '@lc/types/Misc';

import { Award, AwardVerbose } from './types';

export function createCardAward(
	id: number,
	title: string = ``,
	goal: string = ``,
	prize: string = ``,
	// requireTarget = false,
	// requireSource = false,
	requireDecision: boolean = false
): Award {
	const cost = [0, 1, 2];
	const type = 'Award';

	return {
		id,
		cost,
		type,
		title,
		goal,
		prize,
		requireDecision,
	};
}

export function createCardAwardVerbose(
	award: Award,
	action: funcType,
	decisionPrep: funcType = () => ({}),
	determineWinnerId: funcType = () => ({})
): AwardVerbose {
	return {
		...award,
		action,
		decisionPrep,
		determineWinnerId,
	};
}
